import { render, staticRenderFns } from "./SafeForWorkStatusSettings.vue?vue&type=template&id=361e137e&scoped=true&"
import script from "./SafeForWorkStatusSettings.vue?vue&type=script&lang=ts&"
export * from "./SafeForWorkStatusSettings.vue?vue&type=script&lang=ts&"
import style0 from "./SafeForWorkStatusSettings.vue?vue&type=style&index=0&id=361e137e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361e137e",
  null
  
)

export default component.exports